import * as React from 'react';

const ChevronRightArrow = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='10'
    height='14'
    viewBox='0 0 10 14'
    fill='none'
  >
    <path
      d='M0.5 13.75L7.19167 7.14997C7.275 7.06663 7.275 6.9333 7.19167 6.8583L0.5 0.258301H3.76667L8.775 5.26663C9.73333 6.22497 9.73333 7.7833 8.775 8.74163L3.76667 13.75H0.5Z'
      fill='#695F5F'
    />
  </svg>
);

export default ChevronRightArrow;
